/** FNV-1a (32-bit), seeded. Synchronous, dependency-free, stable across sessions. */
const fnv1a = (str: string, seed: number): number => {
  let hash = seed >>> 0;
  for (let i = 0; i < str.length; i++) {
    hash ^= str.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193) >>> 0;
  }
  return hash >>> 0;
};

/**
 * Derive a deterministic, filesystem-safe cache fileName from a URL.
 *
 * Two FNV-1a passes with different seeds give ~64 bits, rendered as base36 and
 * prefixed `u_`. The exact form doesn't matter — only that it's stable (so a
 * prewarmed URL and a later read resolve to the same key) and contains no path
 * separators. The cache stores raw bytes, so no extension is needed.
 */
export const hashUrlToFileName = (url: string): string => `u_${fnv1a(url, 0x811c9dc5).toString(36)}${fnv1a(url, 0x7ee3623b).toString(36)}`;
